/**
 * 触发埋点
 */
function log() {
    console.log('【weblog-wmda】招才猫app暂不支持上报wmda埋点');
}

export default log;
